import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import StoreRating$1 from './StoreRating.js';

var StoreRatingContainer = (_param)=>{
    var { store  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "store"
    ]);
    const { getLabel , getFormattedLabel  } = useIntl();
    const { isStoreRatingsEnabled  } = useFeatureToggles();
    var ref4, ref1;
    const labels = React.useMemo(()=>{
        var ref3, ref2;
        return {
            title: getLabel('stores.component.storeRating.title'),
            rating: getFormattedLabel('stores.component.storeRating.rating', {
                labelData: {
                    rating: (ref4 = (ref3 = store.rating) === null || ref3 === void 0 ? void 0 : ref3.value) !== null && ref4 !== void 0 ? ref4 : ''
                }
            }),
            ratingCount: getFormattedLabel('stores.component.storeRating.ratingCount', {
                labelData: {
                    count: (ref1 = (ref2 = store.rating) === null || ref2 === void 0 ? void 0 : ref2.count) !== null && ref1 !== void 0 ? ref1 : ''
                }
            }),
            description: getLabel('stores.component.storeRating.description'),
            review: getLabel('stores.component.storeRating.review')
        };
    }, [
        getLabel,
        getFormattedLabel,
        store
    ]);
    const urls = React.useMemo(()=>{
        var ref;
        return {
            review: ((ref = store.googlePlaceReviewUrl) === null || ref === void 0 ? void 0 : ref.length) ? store.googlePlaceReviewUrl : undefined
        };
    }, [
        store
    ]);
    const onClickReview = React.useCallback(()=>{
        // TODO: Implement data layer event
        console.log(store);
    }, [
        store
    ]);
    if (!isStoreRatingsEnabled || !store.rating) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(StoreRating$1, swcHelpers.extends({}, rest, {
        labels: labels,
        rating: store.rating.value,
        urls: urls,
        onClickReview: onClickReview
    }));
};
var StoreRating = StoreRatingContainer;

export { StoreRatingContainer, StoreRating as default };
//# sourceMappingURL=StoreRatingContainer.js.map
